var _defs, _path, _path2, _path3, _polygon, _polygon2, _path4, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5333f;}.cls-2{fill:#011e41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.07,100.71a186.28,186.28,0,0,0-230.14,0L125,88.13a202.29,202.29,0,0,1,249.92,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.6,176a28.88,28.88,0,1,1,28.88-28.87A28.9,28.9,0,0,1,249.6,176Zm0-41.75a12.88,12.88,0,1,0,12.88,12.88A12.89,12.89,0,0,0,249.6,134.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.45,187.31a28.88,28.88,0,1,1,28.88-28.87A28.9,28.9,0,0,1,130.45,187.31Zm0-41.75a12.88,12.88,0,1,0,12.88,12.88A12.9,12.9,0,0,0,130.45,145.56Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.01 447.08 219.01 447.08 219.01 241.58 194.98 318.42 182.3 318.42 161.05 251.9 161.05 447.08 145.05 447.08 145.04 195.12 159.71 195.12 188.54 285.39 220.32 183.81 235.01 183.81 235.01 447.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.86 447.08 99.86 447.08 99.86 250.56 79.11 313.64 63.91 308.64 101.26 195.12 115.87 195.12 115.86 447.08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.54,187.31a28.88,28.88,0,1,1,28.88-28.87A28.9,28.9,0,0,1,369.54,187.31Zm0-41.75a12.88,12.88,0,1,0,12.88,12.88A12.89,12.89,0,0,0,369.54,145.56Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "384.14 447.08 384.13 195.12 398.74 195.12 436.09 308.64 420.89 313.64 400.14 250.56 400.14 447.08 384.14 447.08"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "354.95 447.08 338.95 447.08 338.95 250.74 316.78 318.42 304.14 318.42 280.19 241.68 280.2 447.08 264.2 447.08 264.19 183.81 278.89 183.81 310.68 285.65 340.34 195.12 354.95 195.12 354.95 447.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnidad);
export default __webpack_public_path__ + "static/media/unidad.7cf25db6c05e03276edf9e4849fa429e.svg";
export { ForwardRef as ReactComponent };